module.exports = __webpack_public_path__ + "img/senderrand-business-step-2.90bca7e1.svg";